import * as React from "react";
import { useTranslation } from "react-i18next";
import { IfPermitted, PageHeader, DocumentTitle } from "components/common";
import UsersPageNavigation from "components/users/navigation/UsersPageNavigation";
import DocsHelper from "util/DocsHelper";
import CreateButton from "components/common/CreateButton";
import LicenseCheck from "../../license/LicenseCheck";
import TeamsOverview from "../components/teams-overview/TeamsOverview";
const TeamsOverviewPage = () => {
  const { t } = useTranslation("enterprise_security");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("teams_overview_page.title") }, /* @__PURE__ */ React.createElement(UsersPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("teams_overview_page.title"),
      actions: /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "team:create" }, /* @__PURE__ */ React.createElement(LicenseCheck, { featureName: "teams", displayLicenseWarning: false }, ({ licenseIsValid }) => /* @__PURE__ */ React.createElement(CreateButton, { entityKey: "Team", disabled: !licenseIsValid }))),
      documentationLink: {
        title: t("teams_overview_page.documentation_link"),
        path: DocsHelper.PAGES.USERS_ROLES
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("teams_overview_page.description"))
  ), /* @__PURE__ */ React.createElement(TeamsOverview, null));
};
export default TeamsOverviewPage;
